import { PatientTabs } from '~/lib/constants/patients.constants';
import { PatientTabsCollection } from '~/lib/hooks/usePatientTabsCollection';

export enum OverviewPageEvents {
  uniqueEventsOverviewTabButtonClicked = 'Unique Events Overview Tab Button Clicked',
  uniqueTaskOveviewTabButtonClicked = 'Unique Task Overview Tab Button Clicked',
  uniqueNotesOverviewTabButtonClicked = 'Unique Notes Overview Tab Button Clicked',
  viewClinicalMeasurementsOverviewTabButtonClicked = 'View Clinical Measurements Overview Tab Button Clicked',
  viewAssessmentsOverviewTabButtonClicked = 'View Assessments Overview Tab Button Clicked',
  viewCarePlanOverviewTabButtonClicked = 'View Care PlanOverview Tab Button Clicked',
  viewAllNotesOverviewTabButtonClicked = 'View All Notes Overview Tab Button Clicked',
  viewAllTasksOverviewTabButtonClicked = 'View All Tasks Overview Tab Button Clicked',
  viewAllEventsOverviewTabButtonClicked = 'View All Events Overview Tab Button Clicked',
  viewMessagesOverviewTabButtonClicked = 'View Messages Overview Tab Button Clicked',
  alertButtonOverviewTabClicked = 'Alert Button Overview Tab Clicked',
  safetyPlanAddPlanOverviewTabButtonClicked = 'Safety Plan Add Plan Overview Tab Button Clicked',
  lethalMeansAddPlanOverviewTabButtonClicked = 'Lethal Means Add Plan Overview Tab Button Clicked',
  safetyPlanContinueOverviewTabButtonClicked = 'Safety Plan Continue Overview Tab Button Clicked',
  lethalMeansContinueOverviewTabButtonClicked = 'Lethal Means Continue Overview Tab Button Clicked',
  safetyPlanDownloadOverviewTabButtonClicked = 'Safety Plan Download Overview Tab Button Clicked',
  lethalMeansDownloadOverviewTabButtonClicked = 'Lethal Means Download Overview Tab Button Clicked',
  safetyPlanViewOverviewTabButtonClicked = 'Safety Plan View Overview Tab Button Clicked',
  lethalMeansViewOverviewTabButtonClicked = 'Lethal Means View Overview Tab Button Clicked',
}

const OverviewPageLinks: Record<string, OverviewPageEvents> = {
  [PatientTabsCollection[PatientTabs.CLINICAL_PROFILE].subPath]:
    OverviewPageEvents.viewClinicalMeasurementsOverviewTabButtonClicked,
  [PatientTabsCollection[PatientTabs.TASKS].subPath]:
    OverviewPageEvents.viewAllTasksOverviewTabButtonClicked,
  [PatientTabsCollection[PatientTabs.APPOINTMENTS].subPath]:
    OverviewPageEvents.viewAllEventsOverviewTabButtonClicked,
  [PatientTabsCollection[PatientTabs.NOTES].subPath]:
    OverviewPageEvents.viewAllNotesOverviewTabButtonClicked,
  [PatientTabsCollection[PatientTabs.MESSAGES].subPath]:
    OverviewPageEvents.viewMessagesOverviewTabButtonClicked,
  [PatientTabsCollection[PatientTabs.ASSESSMENTS].subPath]:
    OverviewPageEvents.viewAssessmentsOverviewTabButtonClicked,
  [PatientTabsCollection[PatientTabs.CARE_PLAN].subPath]:
    OverviewPageEvents.viewCarePlanOverviewTabButtonClicked,
};

export const getOverviewPageTitle = (
  link: string,
): OverviewPageEvents | undefined => {
  return OverviewPageLinks[link];
};
